module.exports = __webpack_public_path__ + "media/images/service/b_4-ef93354a6bbdf0a3321c58a5142f36b6.png";